import { Icon, Paragraph, Strong } from '@customerio/pluma-components/react';

type DeleteDatabaseMessageProps = {
  name: string;
};

/** The body of the "Delete source" confirmation. */
export function DeleteDatabaseMessage({ name }: DeleteDatabaseMessageProps) {
  return (
    <>
      <Paragraph mb="200">
        <Icon name="critical" color="critical" isInline /> The <Strong>{name}</Strong> source settings will be deleted.
      </Paragraph>
      <Paragraph>
        Are you sure you want to delete the <Strong>{name}</Strong> source?
      </Paragraph>
    </>
  );
}
